import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import UGMK from '../../../assets/images/projects_ugmk.jpg';
import Anzhi from '../../../assets/images/projects_anzhi.jpg';
import Fakel from '../../../assets/images/projects_fakel.jpg';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './projects.scss';
import { useTranslation } from 'react-i18next';

const Projects: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="projects">
            <h2 className="projects__header">{t('projects_section.title')}</h2>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                loop={true}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
            >
                <SwiperSlide className='slide'>
                    <img src={UGMK} alt="photo" className="photo" />
                    <div className="text">
                        <h2 className='text__header'>{t('projects_section.projects.project1.name')}</h2>
                        <p className='text__address'>{t('projects_section.projects.project1.location')}</p>
                        <p className='text__services'>{t('projects_section.projects.project1.services')}</p>
                    </div>
                </SwiperSlide>
                <SwiperSlide className='slide'>
                    <img src={Anzhi} alt="photo" className="photo" />
                    <div className="text">
                    <h2 className='text__header'>{t('projects_section.projects.project2.name')}</h2>
                        <p className='text__address'>{t('projects_section.projects.project2.location')}</p>
                        <p className='text__services'>{t('projects_section.projects.project2.services')}</p>
                    </div>
                </SwiperSlide>
                <SwiperSlide className='slide'>
                    <img src={Fakel} alt="photo" className="photo" />
                    <div className="text">
                    <h2 className='text__header'>{t('projects_section.projects.project3.name')}</h2>
                        <p className='text__address'>{t('projects_section.projects.project3.location')}</p>
                        <p className='text__services'>{t('projects_section.projects.project3.services')}</p>
                    </div>
                </SwiperSlide>
            </Swiper>
        </section>
    )
}

export default Projects;